/* global ReSourceRemoteLogging ReSourceRemoteLoggingEndpoint CSRFMiddlewareToken UserData DyadData PairingData */

import jsan from 'jsan';
import Logger from 'js-logger';
import {createAction} from 'redux-actions';

import ReSourceAPI from './api';
import fetch from './fetch';

Logger.useDefaults({
    defaultLevel: Logger.DEBUG,
});

const consoleHandler = Logger.createDefaultHandler();

Logger.setHandler((messages, context) => {
    consoleHandler(messages, context);

    if (ReSourceRemoteLogging === false) return;

    const [...message] = messages;
    const now = new Date();
    const data = {
        level: context.level.name,
        message: JSON.stringify(message),
        timestamp: now.toISOString(),
    };

    if (context.name) data.name = context.name;

    const request = fetch(ReSourceRemoteLoggingEndpoint, {
        method: 'POST',
        body: data,
        credentials: 'include',
        headers: {
            'X-CSRFToken': CSRFMiddlewareToken,
        },
    });

    request.catch(error => console.log('Error sending log to server:', error));
});

export {Logger};

const storeLogger = Logger.get('js.redux');

/**
 * Redux logging middleware
 *
 * Logs every action dispatched over the redux store
 */
const loggingMiddleware = () => next => action => {
    const {type, payload} = action;

    storeLogger.debug(`Store received action of type ${type} with payload:`, payload);

    return next(action);
};

const REDUX_LOGGER_ACTION = 'logger.redux';
const logToServer = createAction(REDUX_LOGGER_ACTION, message => ({message}));

const createLoggingMiddleware = ({initialState, csrfToken}) => {
    const api = new ReSourceAPI(csrfToken);

    const payload = [];

    return () => next => action => {
        if (action.type === REDUX_LOGGER_ACTION) {
            const {message} = action.payload;

            const body = {
                message,
                UserData,
                DyadData,
                PairingData,
                body: {
                    payload,
                    preloadedState: initialState,
                },
            };

            api.logs.create(jsan.stringify(body, null, null, true));

            return next(action);
        }

        payload.push(jsan.stringify(action));

        return next(action);
    };
};


export {
    loggingMiddleware,
    createLoggingMiddleware,
    logToServer,
};



// WEBPACK FOOTER //
// ./scripts/utils/logging.js